<template>
  <div>
    <li v-if="config.isContract">
      <!-- 选择合同及条款 -->
       <block-title :title="config.isChargeType?'计费方式':'合同条款'">
        <div v-if="config.isChargeType" class="chargeType_content">
          <el-radio-group v-model="form.chargeType" class="chargeType_radio" size="small" @change="handleChange">
            <el-radio
            v-for="item in chargeOption"
            :key="item.value"
            border
            :label="item.value">
            <div class="charge_item">
              <span class="charge_radio_label">{{item.label}}</span>
              <el-tooltip class="item" effect="dark" content="按照导入模板指定应收和应付金额" placement="top">
                <el-icon v-if="item.value===2" class="el-icon-warning"></el-icon>
              </el-tooltip>
            </div>
            </el-radio>
          </el-radio-group>
        </div>
        <div v-if="!config.isChargeType||(config.isChargeType&&form.chargeType===1)" :class="{'contract_bar':config.isChargeType}"  class="template-contract item-content">
          <div class="widthStyle template-info">
            <div>
              <img src="@/assets/img/icon/icon_hetong.png" />
              <span>{{form.contractName}} - {{form.contractTermName}}</span>
            </div>
          </div>
          <a class="change-contract" @click="replaceContract">更换合同条款</a>
        </div>
      </block-title>
    </li>
    <li v-if="config.isProject">
      <block-title title="选择项目">
        <div class="item-content widthStyle">
          <select-dom
              ref="projectRef"
              v-model="form.projectId"
              :list.sync="projectList"
              @checkedList="checkedList"
              @onSearch="onSearchProject"
          />
          <div v-if="!projectALLData.length">
            暂无运营项目，请联系管理员创建
<!--            <a-button style="padding: 0" type="link" @click="toProject"-->
<!--            >创建运营项目</a-button>-->
          </div>
        </div>
      </block-title>
    </li>
    <select-contract
      ref="SelectContract"
      :contract-list="contractList"
      :default-contract-code="form.contractCode"
      :default-term-code="form.contractTermCode"
      @success="successContract"
    />
  </div>
</template>

<script>
import SelectDom from '@/components/select/OrderSelect.vue';
import BlockTitle from '@/components/panel/BlockTitle.vue';
import SelectContract from './SelectContract.vue';
import {chargeOption} from '../constant'

  export default {
    name:'ContractPrject',
    components:{
      SelectDom,
      SelectContract,
      BlockTitle
    },
    props:{
      config:{
        type:Object,
        default:()=>{}
      },
      form:{
        type:Object,
        default:()=>{}
      },
      contractList:{
        type:Array,
        default:()=>[]
      },
      projectList:{
        type:Array,
        default:()=>[]
      },
      projectALLData:{
         type:Array,
        default:()=>[]
      },
      toProject:{
        type:Function
      },
      checkedList:{
         type:Function
      },
      onSearchProject:{
         type:Function
      },
    },
    data(){
      return {
        chargeOption
      }
    },
    methods:{
      successContract(data) {
        this.form.contractCode = data.contractCode
        this.form.contractTermCode = data.contractTermCode
        this.$set(this.form,'contractName', data.contractName)
        this.$set(this.form,'contractTermName', data.contractTermName)
        this.$emit('changeContract',data)
      },
      replaceContract() {
        this.$refs.SelectContract.show()
      },
      handleChange(){
        this.$emit('chargeType')
      }
    }
  }
</script>

<style lang="less" scoped>
.template-contract {
    display: flex;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
    }
    .change-contract {
      margin-left: 24px;
    }
  }
  .template-info {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F2FBF8;
    padding: 0 16px;
    border-radius: 4px;
    .template-info-name {
      img {
        width: 46px;
        height: 46px;
      }
    }
    span {
      color: #171717;
      margin-left: 16px;
    }
    .template-info-download {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
  ::v-deep.chargeType_radio {
  .el-radio__input.is-checked .el-radio__inner,
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #06b880;
    border-color: #06b880;
  }
  .el-radio__inner:hover,
  .el-checkbox__inner:hover,
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #06b880;
  }
  .el-radio__input.is-checked+.el-radio__label,
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #06b880;
  }
  .el-radio__label {
    padding-left: 8px;
  }
  .el-radio {
    margin-right: 20px;
    display: inline-flex;
  }
  .el-radio.is-bordered.is-checked{
    border-color: #06b880;
  }
}
.chargeType_content{
  padding: 10px;
}
.charge_item{
  display: flex;
  align-items: center;
  .charge_radio_label{
    margin-right: 4px;
  }
}
.contract_bar{
  margin: 12px 0;
  padding-bottom: 12px !important;
}
</style>
